package com.example.hukakmp.ui

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import kotlinx.browser.window
import kotlin.js.json

@Composable
actual fun rememberAchievementSharer(): (String) -> Unit = remember {
    { text: String ->
        val navigator = window.navigator.asDynamic()
        val share = navigator.share

        if (share != undefined) {
            share.call(
                navigator,
                json(
                    "title" to "Huka",
                    "text" to text,
                ),
            )
        } else {
            val clipboard = navigator.clipboard
            if (clipboard != undefined) {
                clipboard.writeText(text)
            }
        }
    }
}
